(() => {
  if (window.__SKW_CART_FOCUS__) return;
  window.__SKW_CART_FOCUS__ = true;

  const START = '=== SKW PERSONALISIERUNG ===';
  const END = '=== ENDE SKW PERSONALISIERUNG ===';
  const FIELDS = [
    ['Personalisierung', 'Personalisierung'],
    ['Name', 'Name'],
    ['Wunschtext', 'Wunschtext'],
    ['Datum', 'Datum'],
    ['Jahr', 'Jahr'],
    ['Geburtsdatum', 'Geburtsdatum']
  ];
  let queue = Promise.resolve();

  const clean = value => String(value ?? '').replace(/\s+/g, ' ').trim();
  const stripManaged = note => {
    let text = String(note ?? '');
    let start = text.indexOf(START);
    while (start !== -1) {
      const end = text.indexOf(END, start + START.length);
      if (end === -1) {
        text = text.slice(0, start);
        break;
      }
      text = `${text.slice(0, start)}${text.slice(end + END.length)}`;
      start = text.indexOf(START);
    }
    return text.replace(/\n{3,}/g, '\n\n').trim();
  };
  const prop = (properties, key) => {
    if (!properties) return '';
    if (Array.isArray(properties)) {
      const hit = properties.find(entry => Array.isArray(entry) ? entry[0] === key : entry?.name === key || entry?.key === key);
      return clean(Array.isArray(hit) ? hit[1] : hit?.value);
    }
    return clean(properties[key]);
  };
  const itemBlock = item => {
    const values = FIELDS.map(([key, label]) => [label, prop(item.properties, key)]).filter(([, value]) => value);
    if (!values.length) return '';
    const lines = [
      `Lieferant: ${clean(item.vendor) || 'nicht angegeben'}`,
      `Artikel: ${clean(item.product_title || item.title) || 'nicht angegeben'}`
    ];
    const variant = clean(item.variant_title);
    if (variant && variant.toLowerCase() !== 'default title') lines.push(`Variante: ${variant}`);
    lines.push(`SKU: ${clean(item.sku) || 'nicht angegeben'}`);
    lines.push(`Menge: ${Number(item.quantity) || 1}`);
    values.forEach(([label, value]) => lines.push(`${label}: ${value}`));
    return lines.join('\n');
  };
  const perform = async () => {
    const cartUrl = window.routes?.cart_url || '/cart';
    const updateUrl = window.routes?.cart_update_url || '/cart/update.js';
    const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    const customerNote = stripManaged(cart.note);
    const entries = (cart.items || []).map(itemBlock).filter(Boolean);
    const managed = entries.length ? `${START}\n${entries.join('\n\n')}\n${END}` : '';
    const next = [customerNote, managed].filter(Boolean).join('\n\n');
    if (String(cart.note ?? '').trim() === next.trim()) return;
    await fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note: next })
    });
  };
  const sync = () => {
    queue = queue.catch(() => null).then(perform);
    return queue;
  };
  window.skwSyncPersonalizationOrderNote = sync;
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(sync, 100));
  }
  sync().catch(error => console.error('[SKW] Personalisierungsnotiz konnte nicht synchronisiert werden.', error));
})();